export default "__VITE_ASSET__Ddg80o0u__"